import { createFeatureSelector, createSelector } from '@ngrx/store';
import { clone } from 'app/shared/utilities';
import { profileStoreName } from './actions';
import { ProfileState } from './reducer';

export const selectProfileState = createFeatureSelector<ProfileState>(profileStoreName);
export const selectProfile = createSelector(selectProfileState, (state: ProfileState) => (state?.profile ? clone(state?.profile) : undefined));

